import { ElementType, FormElementProps } from './FormElementParts'
import InputElement from './InputElement'

export const DECIMAL_REGEX = '^\\d+(?:\\.\\d+)?$'
export const INTEGER_REGEX = '^\\d+$'

const curriedKeyDown = (type: ElementType) => {
  return (e: any) => {
    const kbEvent = e as KeyboardEvent
    const theKey = kbEvent.key.toLowerCase()

    switch (theKey) {
      case '.':
        type === ElementType.INTEGER && kbEvent.preventDefault()
        break
      case 'e': // prevent exponential numbers
        kbEvent.preventDefault()
        break
      default:
        break
    }
  }
}

const NumberElement: React.FC<FormElementProps> = (props) => {
  const { type } = props
  const isDecimal = type === ElementType.DECIMAL
  const handleKeyDown = curriedKeyDown(type as ElementType)

  const inputProps = {
    ...props,
    onKeyDown: handleKeyDown,
    pattern: isDecimal ? DECIMAL_REGEX : INTEGER_REGEX,
    step: isDecimal ? 0.01 : 1,
    type: ElementType.NUMBER,
  }

  return <InputElement {...inputProps} />
}

export default NumberElement
